import Onboarding from './views/index.vue';
import OrgSummary from './views/orgSummary.vue';
import clientOrgSummary from './views/clientOrgSummary.vue';

const routes = [
  {
    path: '/orgsummary',
    name: 'orgsummary',
    // redirect: '/orgsummary',
    component: OrgSummary,
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN'||userRole == 'AUDITOR') {
        next();
        return;
      }
      next("/restricted");
    },
  },
  {
    path: '/clientOrgSummary',
    name: 'clientOrgSummary',
    // redirect: '/orgsummary',
    component: clientOrgSummary,
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'CLIENTADMIN') {
        next();
        return;
      }
      next("/restricted");
    },
  },
  {
    path: '/onboarding/entity/:entity_index/:step_name',
    name: 'onboardingentity',
    component: Onboarding,
    props: (route) => ({level: 'entity', entity_index: route.params.entity_index, step_name: route.params.step_name}),
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN') {
        next();
        return;
      }
      next("/restricted");
    },
  },
  {
    path: '/onboarding/:step_name/:entity_index/:sub_step',
    name: 'onboardingent',
    component: Onboarding,
    props: (route) => ({level: 'entity', entity_index: route.params.entity_index, step_name: route.params.step_name, sub_step: route.params.sub_step}),
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN') {
        next();
        return;
      } 
      next("/restricted");
    },
  },
  {
    path: '/onboarding/:step_name',
    name: 'onboardingle',
    component: Onboarding,
    props: (route) => ({level: 'org', step_name: route.params.step_name}),
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN') {
        next();
        return;
      }
      next("/restricted");
    },
  },
  {
    path: '/onboarding/entity/:entity_index/:step_name/:sub_step',
    name: 'onboardingentity',
    component: Onboarding,
    props: (route) => ({level: 'entity', entity_index: route.params.entity_index, step_name: route.params.step_name, sub_step: route.params.sub_step }),
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN') {
        next();
        return;
      }
      next("/restricted");
    },
  },
  {
    path: '/onboarding/:step_name/:sub_step',
    name: 'onboardingbu',
    component: Onboarding,
    props: (route) => ({level: 'org', step_name: route.params.step_name , sub_step: route.params.sub_step,entity_index:route.params.entity_index}),
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN') {
        next();
        return;
      }
      next("/restricted");
    },

  },
  { 
     path: '/onboarding', redirect: '/onboarding/info',
     beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN') {
        next();
        return;
      }
      next("/restricted");
    },
     
  }
];

export default routes;
